import React from 'react';
import Modal from 'react-modal';
import { ReactComponent as CloseIcon } from '../../components/icon/closebuttonicon.svg'; // SVG 아이콘 경로

Modal.setAppElement('#root');

const AlarmModal = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel='No Data Modal'
      className='fixed inset-0 flex items-center justify-center p-4'
      overlayClassName='fixed inset-0 bg-gray-500 bg-opacity-75'
    >
      <div className='relative bg-white w-[90%] max-w-md h-[20%] p-6 rounded-lg shadow-lg overflow-auto'>
        <button onClick={onRequestClose} className='absolute top-2 right-2 text-gray-600 hover:text-gray-800'>
          <CloseIcon className='w-6 h-6' />
        </button>
        <h2 className='text-xl font-bold mb-2'>정보 없음</h2>
        <p>데이터가 없습니다.</p>
      </div>
    </Modal>
  );
};

export default AlarmModal;
